module.exports = __webpack_public_path__ + "img/img_vs.f37385a7.png";